import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Demo() {
  const { applySession, user } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const started = useRef(false);
  useEffect(() => {
    if (started.current || user === null) return;
    started.current = true;
    let visitor = localStorage.getItem("ka_demo_visitor");
    if (!visitor) {
      visitor = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("ka_demo_visitor", visitor);
    }
    api.post("/demo/start", { visitor }).then(async ({ data }) => {
      await applySession(data);
      nav("/app", { replace: true });
    }).catch((e) => setErr(errMsg(e)));
  }, [applySession, nav, user]);
  return (
    <div data-testid="demo-start-page" className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#F7F5F0] px-6 text-center">
      {err ? <>
        <h1 className="font-display text-3xl font-extrabold">Demo unavailable</h1>
        <p data-testid="demo-error" className="text-slate-600">{err}</p>
        <Link to="/" className="font-semibold text-emerald-700 hover:underline">Back to home</Link>
      </> : <>
        <Loader2 className="h-8 w-8 animate-spin text-emerald-600" />
        <h1 className="font-display text-3xl font-extrabold">Opening the demo kitchen…</h1>
        <p className="max-w-md text-slate-600">Loading The Harbour Kitchen with today's checks, temperatures, deliveries and inspector history.</p>
      </>}
    </div>
  );
}
